import { CancelationReasonCell } from '@exam-center/exam-event-examinees';
import { ExamEventExamineeResultLabel } from '@exam-center/exam-event-management';
import { ExamineeProgressIcon } from '@exam-center/proctoring-details';
import { Text, type GridColDef } from '@shared/components';

import { type ExamEventExamineeResultListRow } from './types';

const columns: Readonly<GridColDef<ExamEventExamineeResultListRow>[]> = [
  {
    field: 'seatNumber',
    headerName: 'เลขที่นั่ง',
    width: 80,
    align: 'center',
  },
  { field: 'fullName', headerName: 'ชื่อ-นามสกุล', flex: 1, minWidth: 240, sortable: false },
  { field: 'examCourseId', headerName: 'หลักสูตร', width: 120, sortable: false },
  {
    field: 'certificateStatus',
    headerName: 'Certificate',
    width: 100,
    sortable: false,
    renderCell: (params) =>
      params.row.certificateStatus ? (
        <ExamineeProgressIcon variant={params.row.certificateStatus} />
      ) : (
        '-'
      ),
  },
  {
    field: 'result',
    headerName: 'Results',
    width: 100,
    sortable: false,
    renderCell: (param) => <ExamEventExamineeResultLabel variant={param.row.result} />,
  },
  {
    field: 'status',
    headerName: 'สถานะผู้เข้าสอบ',
    width: 160,
    renderCell: (params) => {
      const status = params.row.status;
      return <Text>{status}</Text>;
    },
    sortable: false,
  },
  {
    field: 'remark',
    headerName: 'Remark',
    width: 160,
    sortable: false,
    renderCell: (params) => {
      const { cancelationReasonCategory, remark } = params.row;

      return (
        <CancelationReasonCell
          cancelationReasonCategory={cancelationReasonCategory}
          remark={remark}
        />
      );
    },
  },
];

export default columns;
